<template>
    <!-- 付汇记录 -->
    <div class="exchange-settlement-record-list">
      <ab-list-query :tabs="tabs" @handleTabs="handleTabs">
        <template #right>
          <el-row :gutter="20">
            <el-col :span="4">
              <el-input
                placeholder="付款申请单号"
                v-model.trim="formSearch.number"
                clearable
              >
              </el-input>
            </el-col>
            <el-col :span="4">
              <ab-select
                v-model="formSearch.revIdDesc"
                url="/bas/client/basSupplier/list"
                :urlData="{ name: formSearch.revIdDesc, pageNum: 1, pageSize: 10, isEnabled: 1 }"
                inputKey="nameOrNumber"
                descKey="name"
                placeholder="收款方"
                @handleSelect="revSelect"
              ></ab-select>
            </el-col>
            <el-col :span="5">
              <ab-timeSearch
                class="searchBox"
                startSrc="实际付款日期起"
                endSrc="实际付款日期止"
                v-model="formSearch.actualPaymentDateArray"
                @searchEvent="actualPaymentDateChange"
              ></ab-timeSearch>
            </el-col>
            <el-col :span="4">
              <ab-timeSearch
                class="searchBox"
                startSrc="创建日期起"
                endSrc="创建日期止"
                v-model="formSearch.createDateArray"
                @searchEvent="createDateChange"
              ></ab-timeSearch>
            </el-col>
            <el-col
              :span="4"
              class="text-left"
            >
              <el-button @click="searchForm">搜索</el-button>
              <el-button
                link
                class="btn-svg"
                @click="resetForm"
              >
                <ab-svg name="qingchu"></ab-svg>清除
              </el-button>
            </el-col>
          </el-row>
        </template>
  
        <template #toolbar>
          <!-- <el-button
            type="primary"
            @click="newPage()"
          >我要付汇</el-button> -->
  
          <el-button
            :loading="loading.delete"
            :disabled="deleteDisabled"
            @click="deleteItem(null)"
          >删除</el-button>
  
          <el-button
            :loading="loading.print"
            :disabled="multiSelected.length !== 1"
            @click="printFile"
          >打印请款书</el-button>
  
          <el-button
            :loading="loading.export"
            @click="exportFile"
          >导出</el-button>
        </template>
  
        <template #table>
          <ab-table
            class="materialTable"
            ref="table"
            stripe
            showEdit
            showSelection
            showMoreEdit
            selectionWidth="45"
            indexWidth="50"
            widths="200"
            isFilter="operator"
            :column-list="columns"
            :table-list="tableData"
            :dataListLoading="loading.table"
            :handleSelectionChange="selectionChange"
            :filterArry="['创建人', '确认人', '创建日期']"
            @filterColumns="filterColumns"
          >
            <template #clientNumber="props">
              <span class="number-primary" @click="showDetail(props.row, props.row.clientStatusDesc == '待提交' ? 'edit': 'view')">{{ props.row.clientNumber }}</span>
            </template>
  
            <template #clientStatusDesc="scope">
              <span :class="getStatusClass(scope.row.clientStatusDesc)"></span>
              {{ scope.row.clientStatusDesc }}
            </template>
            <!-- <template #clientReachStatusDesc="{row}">
              <div v-if="row.clientStatus == '10'">
              <span :class="getStatusClass1(row.clientReachStatusDesc)"></span>
              {{ row.clientReachStatusDesc }}</div>
            </template> -->
  
            <template #operator="scope">
              <el-button
                v-if="scope.row.clientStatus == '01' && scope.row.id"
                type="text"
                :loading="loading.submit"
                link
                @click="submitRow(scope.row.id)"
              >提交</el-button>
  
              <el-button
                v-else-if="scope.row.clientStatus == '05' && scope.row.esignStatus != -1 && $isAuth('customer:account:pay:submit')"
                type="text"
                link
                @click="revoke(scope.row.id)"
              >修改</el-button>
              
              <ab-continue-sign
                v-else-if="scope.row.clientStatus == '02-1'"
                billType="03"
                :customerBillNumber="scope.row.clientNumber"
                type="text"
                link
                @handleClose="searchForm"
              >去签章</ab-continue-sign>
  
              <el-button
                v-else-if="scope.row.tenpayStatus"
                type="text"
                link
                @click="$refs.paymentDetails.init(scope.row.id, scope.row.billType)"
              >付款</el-button>
  
              <el-button
                v-else-if="scope.row.clientStatus == '10'"
                type="text"
                link
                @click="showFileVie(scope.row, '水单')"
              >水单</el-button>
              
              <el-button
                v-else
                type="text"
                link
                @click="showDetail(scope.row, 'view')"
              >详情</el-button>
            </template>
  
            <template #moreOper="scope">
              <el-button
                type="text"
                link
                @click="showDetail(scope.row, 'view')"
              >详情</el-button>
  
              <el-button
                v-if="scope.row.clientStatus == '01' && scope.row.id"
                type="text"
                :loading="loading.submit"
                link
                @click="submitRow(scope.row.id)"
              >提交</el-button>
  
              <el-button
                v-if="scope.row.clientStatus == '01'"
                type="text"
                link
                @click="showDetail(scope.row, 'edit')"
              >编辑</el-button>
  
              <el-button
                v-if="scope.row.clientStatus == '01' && $isAuth('customer:account:pay:delete')"
                type="text"
                :loading="loading.delete"
                link
                @click="deleteItem(scope.row.id)"
              >删除</el-button>
  
              <ab-continue-sign
                v-if="scope.row.clientStatus == '02-1'"
                type="text"
                billType="03"
                :customerBillNumber="scope.row.clientNumber"
                link
                @handleClose="searchForm"
              >去签章</ab-continue-sign>
  
              <ab-revoke-sign
                v-if="scope.row.clientStatus == '02-1'"
                :billId="scope.row.id"
                plain
                link
                :disabled="!$isAuth('customer:account:pay:submit')"
              >撤销章</ab-revoke-sign>
  
              <el-button
                v-if="scope.row.tenpayStatus"
                type="text"
                @click="$refs.paymentDetails.init(scope.row.id, scope.row.billType)"
                link
              >付款</el-button>
  
              <el-button
                v-if="scope.row.clientStatus == '05'"
                type="text"
                :loading="loading.revoke"
                link
                @click="revokeRow(scope.row.id)"
              >撤销单</el-button>
  
              <el-button
                v-if="scope.row.clientStatus == '10'"
                type="text"
                link
                @click="showFileVie(scope.row, '水单')"
              >水单</el-button>
  
              <el-button
                v-if="scope.row.clientStatus == '05'"
                type="text"
                link
                @click="showFileVie(scope.row, '请款书')"
              >委托书</el-button>
  
              <el-button
                v-if="scope.row.clientStatus == '05' && scope.row.esignStatus != -1 && $isAuth('customer:account:pay:submit')"
                type="text"
                link
                @click="revoke(scope.row.id)"
              >修改</el-button>
            </template>
          </ab-table>
          <div style="margin-top: 10px;" v-if="this.multiSelected && this.multiSelected.length">已选付汇总额：<span style="color:red">{{ selectSum }}</span></div>
        </template>
  
        <template #page>
          <ab-page
            :pageTotal="page.total"
            :currentPage="page.currentPage"
            :pageSize="page.pageSize"
            :pageSizes="page.pageSizes"
            @searchForm="pageSearch"
          ></ab-page>
        </template>
      </ab-list-query>
  
      <ab-attPreview :preview="preview"></ab-attPreview>
  
      <!-- 付款明细 -->
      <payment-details @close="searchForm" ref="paymentDetails"></payment-details>
    </div>
  </template>
  
  <script>
  import paymentDetails from './payment-details-drawer.vue'
  
  export default {
    name: 'exchange-settlement-record-list',
    components: {
      paymentDetails
    },
  
    data() {
      return {
        tabs: [
          { name: '全部', value: '', state: '' },
          { name: '待提交', value: '', state: '01' },
          { name: '待付款', value: '', state: '05' },
          { name: '付款中', value: '', state: '06' },
          { name: '待出水单', value: '', state: '08' },
          { name: '已完成', value: '', state: '10' }
        ],
        activedName: '',
        options: {},
        loading: {
          table: false,
          delete: false,
          print: false,
          export: false,
          submit: false,
          revoke: false
        },
        formSearch: {},
        columns: [
          {
            props: 'clientNumber',
            labels: '付款申请单',
            widths: 170,
            slot: 'slot'
          },
          {
            props: 'actualPaymentDate',
            labels: '付款日期',
            widths: 110
          },
          {
            props: 'clientStatusDesc',
            labels: '付款状态',
            widths: 100,
            slot: 'slot'
          },
          
          {
            props: 'custOrderNo',
            labels: '订单编号',
            widths: 170
          },
          {
            props: 'revIdDesc',
            labels: '收款方',
            widths: 180
          },
          {
            props: 'applyAmount',
            labels: '收款金额',
            widths: 100,
            type: 'money',
            align: 'right'
          },
          {
            props: 'applyCurrencyIdDesc',
            labels: '币别',
            widths: 60
          },
          {
            props: 'createByName',
            labels: '创建人',
            widths: 80
          },
  
          {
            props: 'confirmIdDesc',
            labels: '确认人',
            widths: 80
          },
          {
            props: 'createTime',
            labels: '创建日期',
            widths: 170
          }
        ],
        //列表数据
        tableData: [],
        // 勾选行
        multiSelected: [],
        page: {
          currentPage: 1,
          pageSize: 10,
          pageSizes: [10, 20, 50, 100],
          total: 0
        },
        preview: {
          show: false,
          sourceBillType: 'PaymentApp'
        }
      }
    },
  
    computed: {
      deleteDisabled () {
        let start =  this.multiSelected.some((item)=>{
            return item.clientStatus !== '01'
        })
        if(start){
            return true
        }else{
            return false
        }
      },
      selectSum () {
        let sum = 0
        this.multiSelected.map(e => {
            sum = this.$calc.add(sum, e.applyAmount)
        })
        return this.$filters.formatMoney(sum)
      }
    },
  
    activated() {
      this.getSelectList()
      this.searchForm()
    },
    methods: {
      // 修改（撤回）
      revoke(id) {
        this.$confirm('确定要修改吗?修改后需要重新提交，请谨慎操作！', '提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
        }).then(() => {
          this.$get('/sms/client/paymentApp/withdraw', {
            id,
          }).then(({ data }) => {
            if (data.code === 'C0000') {
              this.$message({
                type: 'success',
                message: data.message,
                offset: 380,
                grouping: true
              })
              this.$router.push({
                path: '/exchange-settlement-detail',
                query: {
                  action: 'edit',
                  id
                }
              })
            }
          })
        }).catch(() => {})
      },
      handleTabs(item) {
        this.activedName = item
        this.searchForm()
      },
  
      getSelectList() {
        this.$get('/sms/client/paymentApp/getSelect').then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.options = data.result
          } else {
            this.options = {}
          }
        })
      },
  
      // 收款方
      revSelect(row) {
        if (row && row.id) {
          this.formSearch.revId = row.id
        } else {
          this.formSearch.revId = ''
        }
        this.searchForm()
      },
      
      // 实际付款日期
      actualPaymentDateChange(value) {
        if (value) {
          this.formSearch.actualPaymentDateBegin = value[0]
          this.formSearch.actualPaymentDateEnd = value[1]
        } else {
          this.formSearch.actualPaymentDateBegin = ''
          this.formSearch.actualPaymentDateEnd = ''
        }
        this.searchForm()
      },
      
      // 制单日期
      createDateChange(value) {
        if (value) {
          this.formSearch.startDate = value[0]
          this.formSearch.endDate = value[1]
        } else {
          this.formSearch.startDate = ''
          this.formSearch.endDate = ''
        }
        this.searchForm()
      },
  
      filterColumns(array) {
        this.columns = array
      },
  
      searchForm() {
        this.page.currentPage = 1
        this.getDataList()
      },
  
      resetForm() {
        this.formSearch = {}
      },
  
      pageSearch(obj) {
        this.page.currentPage = obj.currentPage
        this.page.pageSize = obj.pageSize
        this.getDataList()
      },
  
      getDataList() {
        let params = Object.assign({}, this.formSearch)
        params.clientStatus = this.activedName
        params.entrustType = 'export'
        this.$post('/sms/client/paymentApp/list', {
          data: params,
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize
        }, this.loading, 'table').then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.tableData = data.result.list
            this.page.total = data.result.total
            this.tabs.forEach(e => {
              if (e.name === '待提交') {
                e.value = data.extra && data.extra.clientStatus_01 || 0
              } else if (e.name === '待付款') {
                e.value = data.extra && data.extra.clientStatus_05 || 0
              } else if (e.name === '付款中') {
                e.value = data.extra && data.extra.clientStatus_06 || 0
              } else if (e.name === '待出水单') {
                e.value = data.extra && data.extra.clientStatus_08 || 0
              }
            })
          }
        })
      },
  
      selectionChange(array) {
        this.multiSelected = array
      },
  
      getStatusClass(value) {
        let cls = ''
        switch (value) {
          case '付款中': // 付款中
            cls = 'status-0A7CFF'
            break
          case '待付货款': // 待付款
            cls = 'status-13227A'
            break
          case '已完成': // 已完成
            cls = 'status-0AB2A8'
            break
          case '待提交':
          case '待签章':
            cls = 'status-E21010'
            break
          case '待出水单':
            cls = 'status-FF8400'
            break
          default:
            cls = 'status-B1B1B1'
            break;
        }
        return cls
      },
      getStatusClass1(value) {
        let cls = value ? 'status-E21010' : ''
        switch (value) {
          case '已转出': // 付款中
            cls = 'status-13227A'
            break
          case '处理中': // 待付款
            cls = 'status-FF8400'
            break
          case '已到账': // 已完成
            cls = 'status-0AB2A8'
            break
          case '已退回':
            cls = 'status-FF8400'
            break
        }
        return cls
      },
  
      // 我要付汇
      newPage() {
        this.$router.push({
          path: '/pledging-payment-detail',
          query: {
            action: 'add'
          }
        })
      },
  
      // 删除
      deleteItem(id) {
        if(!id && this.multiSelected.length == 0){
            this.$message({
                type: 'error',
                message: '请选择要删除的数据',
                offset: 380,
                grouping: true
            })
            return
        }
        this.$confirm(`删除后无法恢复，确定要删除吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          this.$post('/sms/client/paymentApp/del', {
            ids: id ? [ id ] : this.multiSelected.map(e => e.id)
          }, this.loading, 'delete').then(({ data }) => {
            if (data && data.code === 'C0000') {
              this.$message({
                type: 'success',
                message: data.message,
                offset: 380,
                grouping: true
              })
              this.searchForm()
            }
          })
        }).catch(() => {})
      },
  
      // 打印请款书
      printFile() {
        this.loading.print = true
        this.$get('/sms/client/paymentApp/expEntrust', {
          id: this.multiSelected[0].id,
        }).then(({ data }) => {
          if (data.code === 'C0000') {
            window.open(data.result)
          }
        }).finally(() => {
          this.loading.print = false
          this.searchForm()
        })
      },
  
      // 导出
      exportFile() {
        let params = Object.assign({}, this.formSearch)
        params.clientStatus = this.activedName
        params.entrustType = 'export'
        params.columns = this.columns.map(e => e.props)
        params.paymentAppVoList = this.multiSelected.length ? this.multiSelected : undefined
        this.$post('/sms/client/paymentApp/expList', {
          data: params,
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize
        }, this.loading, 'export').then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.$message({
              type: 'success',
              message: data.message,
              offset: 380,
              grouping: true
            })
            window.open(data.result)
          }
        })
      },
  
      // 提交
      submitRow(id, flag) {
        this.loading.submit = true
        let params = {id}
        if(flag) {
          params.continueSubmit = true
        }
        this.$get('/sms/client/paymentApp/confirm', params).then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.$message({
              type: 'success',
              message: data.message,
              offset: 380,
              grouping: true
            })
          }
          if(data.code === 'E0008'){
            if(data.message && data.message.indexOf('中国') != -1) {
              this.$alert(data.message, '温馨提示', {
                confirmButtonText: '我知道了',
                callback: action => {
                }
              });
            }
            if(data.message && data.message.indexOf('中国') == -1) {
              this.$confirm(data.message, '温馨提示', {
                confirmButtonText: '继续提交',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.submitRow(id, true)
              })
            }
          }
        }).finally(()=>{
          this.loading.submit = false
          this.searchForm()
        })
      },
  
      // 查看附件
      showFileVie(row, fileType) {
        this.preview.sourceBillId = row.id
        this.preview.attachType = fileType === '请款书' ? '030' : '020'
        this.preview.show = true
      },
  
      // 详情/编辑
      showDetail(row, action) {
        this.$router.push({
          path: '/exchange-settlement-detail',
          query: {
            action: action,
            id: row.id
          }
        })
      },
  
      // 撤销单
      revokeRow(id) {
        this.loading.revoke = true
        this.$get('/sms/client/paymentApp/withdraw', { id }).then(({ data }) => {
          if (data.code === 'C0000') {
            this.$message({
              type: 'success',
              message: data.message,
              offset: 380,
              grouping: true
            })
            this.searchForm()
          }
        }).finally(() => {
          this.loading.revoke = false
        })
      }
    }
  }
  </script>
  
  <style lang="scss">
  .exchange-settlement-record-list {
    .el-table-fixed-column--right {
      .el-button + .el-button {
        position: relative;
        margin-left: 14px !important;
        &::before {
          content: '';
          position: absolute;
          left: -8px;
          top: 4px;
          width: 1px;
          height: 10px;
          background: #bfbfbf;
        }
      }
    }
  }
  </style>
  